import React from 'react';

import '../styles/waitlist.css';

const BACKGROUND_SRC = '/images/waitlist/background.png';
const STAR_SRC = '/images/waitlist/star-gray.svg';
const BRANDMARK_SRC = '/images/login/brandmark.svg';
const WORDMARK_SRC = '/images/login/logo-text.svg';

const STAR_POSITIONS = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];

/**
 * Brand lockup shared by every waiting-list screen (brandmark + wordmark).
 * `size="small"` is the 24.961 x 29.527 / 142.72 x 32 lockup used on the
 * wizard and confirmation cards; the default is the landing's 31.201 x 36.909
 * / 178.4 x 40 lockup.
 */
export function WaitlistLogo({ size = 'large' }) {
    const className = size === 'small' ? 'waitlist-logo waitlist-logo-small' : 'waitlist-logo';
    return (
        <div className={className} role="img" aria-label="specific ai">
            <img className="waitlist-logo-brandmark" src={BRANDMARK_SRC} alt="" />
            <img className="waitlist-logo-text" src={WORDMARK_SRC} alt="" />
        </div>
    );
}

/**
 * Page chrome for the waiting list (Figma MVP-DESIGNES 9136:2772 and
 * siblings): full-bleed backdrop with a 5% overlay, four gray stars, two
 * rotated glass panels, a top-right action slot and the 760px content card.
 *
 * `variant` picks the card geometry: `landing` (centred, gap 45),
 * `wizard` (left-aligned, gap 24) or `done` (left-aligned, lower on the page).
 */
export default function WaitlistLayout({ variant = 'landing', topRight = null, children }) {
    return (
        <div className={`waitlist-page waitlist-page-${variant}`}>
            <div className="waitlist-backdrop" aria-hidden="true">
                <img className="waitlist-backdrop-image" src={BACKGROUND_SRC} alt="" />
                <div className="waitlist-backdrop-overlay" />
            </div>
            {STAR_POSITIONS.map((position) => (
                <div key={position} className={`waitlist-star waitlist-star-${position}`} aria-hidden="true">
                    <img src={STAR_SRC} alt="" />
                </div>
            ))}
            <div className="waitlist-glass waitlist-glass-outer" aria-hidden="true">
                <div className="waitlist-glass-panel" />
            </div>
            <div className="waitlist-glass waitlist-glass-inner" aria-hidden="true">
                <div className="waitlist-glass-panel" />
            </div>
            {topRight ? <div className="waitlist-top-right">{topRight}</div> : null}
            <main className={`waitlist-card waitlist-card-${variant} fs-unmask`}>{children}</main>
        </div>
    );
}
